import React from "react";
import GetInTouch from "./GetInTouch";
import QuickContact from "./QuickContact";
import Map from "../map";

function Contact() {
  return (
    <section className="contact no-padding-bottom" data-scroll-index="6">
      <div className="container margin-100px-bottom md-margin-70px-bottom sm-margin-50px-bottom">
        <div className="row">
          <div className="col-12 center-col margin-70px-bottom sm-margin-40px-bottom xs-margin-30px-bottom text-center">
            <h3 className="font-weight-700 font-size32 md-font-size27 sm-font-size24 xs-font-size20 section-title">
              Contact
            </h3>
          </div>
        </div>
        <GetInTouch />
      </div>
      <Map />
      <div className="bg-light-gray padding-30px-tb border-top border-color-medium-gray">
        <div className="container">
          <QuickContact />
        </div>
      </div>
    </section>
  );
}
export default Contact;
